import { jsx as _jsx } from "react/jsx-runtime";
import { getOrgRoutePermissions } from '@repo/guards/route-checks';
import { createFileRoute, Outlet } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization')({
    component: Component,
    loader: async (param)=>{
        let { params, context: { queryClient } } = param;
        const permissions = await getOrgRoutePermissions(queryClient, params.organization);
        return {
            permissions
        };
    }
});
function Component() {
    return /*#__PURE__*/ _jsx(Outlet, {});
}
